<template>
    <div ref="cardHolder" class="full-width" v-loading="loading">
        <!--    搜索框    -->
        <div :class="documentWidth < 768 ? 'search-box-mobile' : 'search-box'">
            <div class="search-input">
                <el-input
                    v-model="keyword"
                    class="w-50 m-2"
                    size="large"
                    placeholder="搜索..."
                    :suffix-icon="Search"
                    @change="changeKeyword"
                />
            </div>

            <div class="operation-box">
                <span @click="insertAddressBookVisible = true"><font-awesome-icon icon="fa-regular fa-square-plus" /></span>
            </div>

            <div class="card-holder-part">
                <!--      收录的名片      -->
                <myCardHolderList :cardList="resultList" />
            </div>

            <!--  通讯录  -->
            <userAdressBookList :addressBookList="addressBookList" @deleteSuccess="deleteAddressBookSuccess" />

            <!--      添加通訊錄彈框      -->
            <inputAddressBookDialog :dialogVisible="insertAddressBookVisible" @submit-success="submitAddressBookCallback" @closeDialog="closeDialog" />
        </div>
    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, watch} from "vue";
    import myCardHolderList from "@/components/shopopee/card/myCardHolderList"
    import userAdressBookList from "@/components/shopopee/card/userAdressBookList"
    import inputAddressBookDialog from "@/components/shopopee/dialog/inputAddressBookDialog"
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faSquarePlus } from '@fortawesome/free-regular-svg-icons'
    import {Search} from '@element-plus/icons-vue';
    import cardApi from "@/request/api"
    import util from "@/util/util"

    library.add(faSquarePlus)

    const props = defineProps(["cardObj"])
    const emits = defineEmits([])

    const { proxy } = getCurrentInstance()

    const documentWidth = ref(375)
    const keyword = ref("")
    const queryObj = ref({})
    const resultList = ref([])

    //通讯录列表
    const addressBookList = ref([])
    //添加通訊錄開關
    const insertAddressBookVisible = ref(false)

    const loading = ref(false)

    watch(() => props.cardObj, (newValue, oldValue) => {
        if (null != newValue && null != newValue.id && null != newValue.login){
            queryAddressBookCardList(fillAddressBook)
        }
    });

    function changeKeyword(){
        queryObj.value.keyword = keyword.value
        if (null != props.cardObj && null != props.cardObj.id && null != props.cardObj.login){
            queryAddressBookCardList(fillAddressBook)
        }
    }

    function queryAddressBookCardList(callback){
        queryObj.value.additionalRecord1.addinfo1 = props.cardObj.id
        queryObj.value.additionalRecord1.login = props.cardObj.login
        loading.value = true
        cardApi.queryAddressBookCardList.send(queryObj.value, callback)
    }

    function fillAddressBook(res){
        loading.value = false
        if (res.code == 200){
            if (null != res.detail){
                if (res.detail.page.list.length > 0){
                    resultList.value = res.detail.page.list
                }else{
                    resultList.value = []
                }

                if (res.detail.list.length > 0){
                    addressBookList.value = res.detail.list
                }else{
                    addressBookList.value = []
                }
            }
        }
    }

    function submitAddressBookCallback(){
        queryAddressBookCardList(fillAddressBook)
    }

    function deleteAddressBookSuccess(index){
        addressBookList.value.splice(index, 1)
    }

    function closeDialog(){
        insertAddressBookVisible.value = false
    }

    onMounted(() => {
        documentWidth.value = proxy.$refs.cardHolder.offsetWidth

        queryObj.value = cardApi.queryAddressBookCardList.getParams()

        if (null != props.cardObj){
            queryAddressBookCardList(fillAddressBook)
        }

    })
</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .search-box{
        margin-top: 15px;
        margin-bottom: 15px;
        width: 100%;
        text-align: center;
        position: relative;
    }

    .search-box .search-input{
        width: 600px;
        margin: auto;
    }

    .search-box .operation-box {
        position: absolute;
        right: 40px;
        top: 0;
        line-height: 40px;
        font-size: 30px;
        cursor: pointer;
    }

    .search-box-mobile{
        margin-top: 15px;
        margin-bottom: 15px;
        width: 100%;
        text-align: center;
        position: relative;
    }

    .search-box-mobile .search-input{
        width: calc(100% - 100px);
        margin: auto;
    }

    .search-box-mobile .operation-box {
        position: absolute;
        right: 10px;
        top: 0;
        line-height: 40px;
        font-size: 30px;
        cursor: pointer;
    }

    .card-holder-part {
        width: 100%;
        margin-bottom: 20px;
    }
</style>